import i18next from "i18next";
import React from "react";
import { useUser } from "../../../Api/userApi";

const Avatar = () => {
    const handleClick = () => {
        location.href = "/mein-konto/";
    };
    const { user } = useUser();
    const { iconPath } = reactConfig;

    return (
        <button id="avatar" onClick={handleClick}>
            <div className="icon-wrapper">
                {user ? (
                    <img src={`${iconPath}/profile-icon.svg`} />
                ) : (
                    <i className="fas fa-user"></i>
                )}
            </div>
            <span className="avatar__text">
                {user
                    ? i18next.t("header.avatar.loggedIn")
                    : i18next.t("header.avatar.loggedOut")}
            </span>
        </button>
    );
};

export default Avatar;
